import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  getE4vhpAnthropometricMeasurements,
  getE4vhpEstablishments,
  getE4vhpExpressionNeeds,
  getE4vhpHomeAssessments,
  getE4vhpPatients,
  getE4vhpTrials,
} from "../../../actions/stats/stats";

class StatsE4vhp extends React.Component {
  render() {
    const links = [
      {
        fileName: "e4vhp_crf_par_clients",
        onExport: this.props.onGetE4vhpEstablishments,
        formattedMessage: "Nb.CRF.By.Psdm",
      },
      {
        fileName: "e4vhp_patients_par_clients",
        onExport: this.props.onGetE4vhpPatients,
        formattedMessage: "Nb.Patients.By.Psdm",
      },
      {
        fileName: "e4vhp_expressions_besoin_par_clients",
        onExport: this.props.onGetE4vhpExpressionNeeds,
        formattedMessage: "Nb.Expression.Needs.By.Psdm",
      },
      {
        fileName: "e4vhp_mesures_anthro_par_clients",
        onExport: this.props.onGetE4vhpAnthropometricMeasurements,
        formattedMessage: "Nb.Anthropometric.Measurements.By.Psdm",
      },
      {
        fileName: "e4vhp_essais_par_clients",
        onExport: this.props.onGetE4vhpTrials,
        formattedMessage: "Nb.Trials.By.Psdm",
      },
      {
        fileName: "e4vhp_audits_securisation_par_clients",
        onExport: this.props.onGetE4vhpHomeAssessments,
        formattedMessage: "Nb.Home.Assessments.By.Psdm",
      },
    ];

    const linksNode = links.map((link, index) => {
      return (
        <li key={index}>
          <button
            className="btn btn-link"
            onClick={() =>
              this.props.openConfModal(link.fileName, (successCallback) =>
                link.onExport(successCallback),
              )
            }
          >
            <FormattedMessage id={link.formattedMessage} />
          </button>
        </li>
      );
    });

    return (
      <div>
        <ul style={{ listStyleType: "none" }}>{linksNode}</ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetE4vhpEstablishments: (successCallback) =>
      dispatch(getE4vhpEstablishments(successCallback)),
    onGetE4vhpPatients: (successCallback) =>
      dispatch(getE4vhpPatients(successCallback)),
    onGetE4vhpExpressionNeeds: (successCallback) =>
      dispatch(getE4vhpExpressionNeeds(successCallback)),
    onGetE4vhpAnthropometricMeasurements: (successCallback) =>
      dispatch(getE4vhpAnthropometricMeasurements(successCallback)),
    onGetE4vhpTrials: (successCallback) =>
      dispatch(getE4vhpTrials(successCallback)),
    onGetE4vhpHomeAssessments: (successCallback) =>
      dispatch(getE4vhpHomeAssessments(successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(StatsE4vhp));
